import { ContractParty } from "@remi/enums/contract-party";

import { hasCapability, type User } from "../base";

export const ntp = {
  accept: ({
    user,
    isUpsellNeeded,
    contractParty,
  }: {
    user: User;
    isUpsellNeeded: boolean;
    contractParty: ContractParty;
  }) => {
    if (isUpsellNeeded && contractParty === ContractParty.REMI) {
      return hasCapability(user, "ntp.accept.upsell");
    }
    return hasCapability(user, "ntp.accept");
  },
};
